import { render } from "./DetailsPanel.vue?vue&type=template&id=5915ee00&scoped=true&ts=true"
import script from "./DetailsPanel.vue?vue&type=script&lang=ts"
export * from "./DetailsPanel.vue?vue&type=script&lang=ts"

import "./DetailsPanel.vue?vue&type=style&index=0&id=5915ee00&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5915ee00"]])

export default __exports__